import type { User } from '@/types/api';

export type Doctor = { id: string; name: string };

/**
 * The doctors a user records for: a doctor only themselves, a nurse her own
 * doctors when linked, otherwise all of them.
 */
export function doctorsFor(
  user: Pick<User, 'id' | 'role' | 'doctorIds'>,
  all: readonly Doctor[]
): Doctor[] {
  if (user.role === 'DENTIST') return all.filter((d) => d.id === user.id);
  if (user.role !== 'ASSISTANT' || !user.doctorIds.length) return [...all];
  const linked = all.filter((d) => user.doctorIds.includes(d.id));
  return linked.length ? linked : [...all];
}

/**
 * The doctor in the selector: the stored pick while it is still offered, else
 * the user themselves when they are a doctor, else the first one.
 */
export function pickDoctor(
  user: Pick<User, 'id'>,
  doctors: readonly Doctor[],
  stored: string | null
): string | null {
  if (stored && doctors.some((d) => d.id === stored)) return stored;
  if (doctors.some((d) => d.id === user.id)) return user.id;
  return doctors[0]?.id ?? null;
}
